import React from 'react';

const BlogPublico = ({ entradas }) => {
  // Asegúrate de que entradas sea un array válido
  const entradasValidas = Array.isArray(entradas) ? entradas : [];

  return (
      <div className="container-fluid p-4">
        <h1 className="h2 mb-5 text-center">Blog Público</h1>

        {entradasValidas.length > 0 ? (
          <div className="row">
            {entradasValidas.flatMap((entrada, index) => (
              <div key={index} className="col-12 col-md-6 col-lg-4">
                <div className="card mb-4 shadow-sm">
                  <img
                    src={entrada.imagen || 'https://via.placeholder.com/400'}
                    alt={entrada.titulo}
                    className="card-img-top"
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="badge bg-primary">{entrada.categoria || 'General'}</span>
                      <small className="text-muted">{entrada.fecha || 'Fecha desconocida'}</small>
                    </div>
                    <h5 className="card-title">{entrada.titulo}</h5>
                    <p className="card-text text-truncate">
                      {entrada.contenido.length > 100
                        ? `${entrada.contenido.substring(0, 100)}...`
                        : entrada.contenido}
                    </p>
                    <div className="d-grid">
                      <button className="btn btn-outline-primary">Leer más</button>
                    </div>
                  </div>
                  <div className="card-footer text-muted d-flex justify-content-between align-items-center">
                    <small>{entrada.autor || 'Autor desconocido'}</small>
                    <small>
                      <i className="fas fa-comments"></i> {entrada.comentarios || 0} comentarios
                    </small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center">No hay entradas disponibles.</p>
        )}
      </div>
  );
};

// Datos de ejemplo (fake)
const entradas = [
  {
    titulo: 'Cómo mejorar tus habilidades en JavaScript',
    contenido: 'En este artículo exploraremos diversas estrategias para mejorar tus habilidades de programación...',
    categoria: 'Desarrollo',
    fecha: '25 de Septiembre, 2024',
    autor: 'Juan Pérez',
    comentarios: 12,
    imagen: 'https://via.placeholder.com/600x400?text=JavaScript',
  },
  {
    titulo: 'Las mejores prácticas en diseño UX/UI',
    contenido: 'El diseño de experiencia de usuario es fundamental para crear productos digitales exitosos...',
    categoria: 'Diseño',
    fecha: '20 de Septiembre, 2024',
    autor: 'Ana López',
    comentarios: 8,
    imagen: 'https://via.placeholder.com/600x400?text=UX+Design',
  },
  {
    titulo: 'Guía completa sobre React para principiantes',
    contenido: 'React es una biblioteca de JavaScript ampliamente utilizada en el desarrollo de aplicaciones web...',
    categoria: 'Frontend',
    fecha: '15 de Septiembre, 2024',
    autor: 'Carlos Gutiérrez',
    comentarios: 15,
    imagen: 'https://via.placeholder.com/600x400?text=React+JS',
  },
];

const BlogApp = () => {
  return <BlogPublico entradas={entradas} />;
};

export default BlogApp;
